import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-grid p-fluid"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Müşteri")
], -1)
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Artikel Numarası")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "col-md-2",
  style: {"margin-top":"25px"}
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Sipariş Durumu")
], -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Sezon")
], -1)
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Order")
], -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Kumaş Onay")
], -1)
const _hoisted_21 = { class: "p-inputgroup" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "öko-Tex")
], -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Departman")
], -1)
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Model Kodu")
], -1)
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Marka")
], -1)
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Yükleme Şekli")
], -1)
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Sipariş Şekli")
], -1)
const _hoisted_37 = {
  class: "row",
  style: {"margin-top":"10px"}
}
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Sip. Tarihi ")
], -1)
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Yük. Tarihi")
], -1)
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Varış Tarihi")
], -1)
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Üretici")
], -1)
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-flex align-items-center fs-6 fw-bold form-label mb-2",
  style: {"margin-top":"11px"}
}, null, -1)
const _hoisted_50 = {
  class: "row",
  style: {"margin-top":"5px"}
}
const _hoisted_51 = { class: "d-flex flex-wrap text-end flex-stack mb-12" }
const _hoisted_52 = {
  key: 1,
  type: "button",
  class: "btn btn-light-primary",
  style: {"float":"right","margin-left":"auto"}
}

import Checkbox from "primevue/checkbox";
import {
  defineComponent,
  ref,
  reactive,
  computed,
  watch,
  h,
  getCurrentInstance,
  withDefaults,
  watchEffect,
  onBeforeUpdate,
} from "vue";

import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import Customer from "@/components/customers/CustomerSingleSelect.vue";
import Season from "@/components/seasons/Season.vue";
import Department from "@/components/departments/Department.vue";
import Brand from "@/components/brands/Brand.vue";
import ShippingTypes from "@/components/shippingTypes/ShippingTypes.vue";
import OrderTypes from "@/components/orderTypes/OrderTypes.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import NexeraFileUpload from "@/components/NexeraFileUpload.vue";
import Order from "@/types/Order";
import CustomerModel from "@/types/Customer";
import SupplierModel from "@/types/Supplier";
import DepartmentModel from "@/types/Department";
import SeasonModel from "@/types/Season";
import Status from "./Status.vue";
import Folder from "@/components/files/Folder.vue";
import File from "@/components/files/File.vue";
import JwtService from "@/core/services/JwtService";
import Calendar from "primevue/calendar";
import Button from "primevue/button";
export interface PropsModel {
  data: any;
}
import { useRouter, useRoute } from "vue-router";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    data: { default: {} }
  },
  setup(__props: any) {

const props = __props as { data: any }

const displayBasic = ref(false);

// Türkçe locale tanımı
const trLocale = {
  firstDayOfWeek: 1,
  dayNames: [
    "Pazar",
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi",
  ],
  dayNamesShort: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
  dayNamesMin: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  monthNames: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ],
  monthNamesShort: [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara",
  ],
  today: "Bugün",
  clear: "Temizle",
};


const upload = (args) => {
  for (let i = 0; i < args.length; i++) {
    files.value.push(args[i]);
  }
};
const toast = useToast();
const store = useStore();
const isActive = ref(false);
const files: any = ref([]);
const date: any = ref();
const estimatedDeliveryDate: any = ref();
const estimatedShippingDate: any = ref();
const router = useRouter();
// console.log(moment(store.state.OrderModule.order.value.estimatedShippingDate).format(
//     "yyyy-MM-DD"
//   ))
// FabricApproval için Date object'e çevir
const convertToDateObject = (dateValue: any) => {
  if (!dateValue || dateValue === "Invalid Date" || dateValue === "") {
    return null;
  }

  try {
    let momentDate;

    // DD.MM.YYYY formatını dene (ör: 19.06.2025)
    if (typeof dateValue === "string" && dateValue.includes(".")) {
      momentDate = moment(dateValue, "DD.MM.YYYY");
    } else if (typeof dateValue === "string") {
      // Diğer string formatlar
      momentDate = moment(dateValue);
    } else if (dateValue instanceof Date) {
      // Zaten Date object ise
      return dateValue;
    } else {
      momentDate = moment(dateValue);
    }

    if (momentDate.isValid()) {
      return momentDate.toDate(); // Date object'e çevir
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

let order: any = ref({
  articleNumber: props.data.articleNumber,
  date: moment(props.data.date).format("yyyy-MM-DD"),
  explain: props.data.explain,
  modelCode: props.data.modelCode,
  estimatedDeliveryDate: moment(props.data.estimatedDeliveryDate).format(
    "yyyy-MM-DD"
  ),
  estimatedShippingDate: moment(
    store.state.OrderModule.order.value.estimatedShippingDate
  ).format("yyyy-MM-DD"),
  customerId: props.data.customer.id,
  departmentId: props.data.department.id,
  brandId: props.data.brand?.id,
  shippingTypeId: props.data.shippingType?.id,
  orderTypeId: props.data.orderType?.id,
  seasonId: props.data.season.id,
  supplierId: props.data.supplier.id,
  code: props.data.code == null ? null : props.data.code,
  externalId: props.data.externalId,
  id: props.data.id,
  isActive: props.data.isActive,
  oekoTex: props.data.oekoTex,
  flag: props.data.flag,
  fabricApproval: convertToDateObject(props.data.fabricApproval),
});

const selectedStatus = (args) => {
  order.value.isActive = args.value.value;
};
const route = useRoute();
var body = document.body;

const toggleModal = () => {
  isActive.value = !isActive.value;
  if (isActive.value) {
    body.classList.add("p-overflow-hidden");
  } else {
    body.classList.remove("p-overflow-hidden");
  }
};
const customer = { name: props.data.customer.name, id: props.data.customer.id };
const brand = {
  name: props.data.brand?.name,
  id: props.data.brand?.id,
};
const shippingType = {
  name: props.data.shippingType?.name,
  id: props.data.shippingType?.id,
};

const orderType = {
  name: props.data.orderType?.name,
  id: props.data.orderType?.id,
};

const department = {
  name: props.data.department.name,
  id: props.data.department.id,
};
const season = { name: props.data.season.name, id: props.data.season.id };
const supplier = { name: props.data.supplier.name, id: props.data.supplier.id };
const statusData = { id: props.data.isActive };
const selectedCustomer = (args) => {
  if (!args.value) {
    order.value.customerId = null;
  } else {
    order.value.customerId = args.value.value;
  }
};
const selectedSeason = (args) => {
  if (!args.value) {
    order.value.seasonId = null;
  } else {
    order.value.seasonId = args.value.value;
  }
};
const selectedDepartment = (args) => {
  if (!args.value) {
    order.value.departmentId = null;
  } else {
    order.value.departmentId = args.value.value;
  }
};
const selectedBrand = (args) => {
  if (!args.value) {
    order.value.brandId = null;
  } else {
    order.value.brandId = args.value.value;
  }
};

const selectedShippingType = (args) => {
  if (!args.value) {
    order.value.shippingTypeId = null;
  } else {
    order.value.shippingTypeId = args.value.value;
  }
};

const selectedOrderType = (args) => {
  if (!args.value) {
    order.value.orderTypeId = null;
  } else {
    order.value.orderTypeId = args.value.value;
  }
};

const selectedSupplier = (args) => {
  if (args.value == null) {
    order.value.supplierId = null;
  } else {
    order.value.supplierId = args.value.value;
  }
};
const removeFiles = (args) => {
  Swal.fire({
    title: "İlgili kayıt silinsin mi?",
    text: "Emin misiniz? Bu işlemi geri alamazsınız!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Evet, Sil!",
    cancelButtonText: "İptal",
  }).then((result) => {
    // <--
    if (result.value) {
      // <-- if confirmed
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      store
        .dispatch(Actions.REMOVE_FILE, args)
        .then((x) => {
          store.dispatch(Actions.ORDER_DETAIL, route.params.id).then((f) => {
            toast.add({
              severity: "success",
              summary: "İşlem Sonucu",
              detail: x.message,
              life: 3000,
            });

            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          });
        })
        .catch((e) => {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        });
    }
  });
};

const updateOrder = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

  if (!order.value.code) {
    error("Order alanını doldurun!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  if (!order.value.modelCode) {
    error("Model Kodunu doldurun!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  if (!order.value.articleNumber) {
    error("Artikel Numarasını doldurun!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  if (!order.value.estimatedDeliveryDate) {
    error("Yükleme Tarihini doldurun!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  if (!order.value.estimatedShippingDate) {
    error("Varış Tarihini doldurun!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }
  if (!order.value.departmentId) {
    error("Departman seçimi zorunlu!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  if (!order.value.customerId) {
    error("Müşteri seçimi zorunlu!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  if (!order.value.seasonId) {
    error("Sezon seçimi zorunlu!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  if (!order.value.supplierId) {
    error("Üretici seçimi zorunlu!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  // FormData için order'ın kopyasını oluştur - orijinal değeri korumak için
  let orderCopy = { ...order.value };

  // Kumaş onay tarihini string formatına dönüştür (sadece kopya için)
  if (orderCopy.fabricApproval && orderCopy.fabricApproval !== "Invalid Date") {
    try {
      // Farklı tarih formatlarını dene
      let momentDate;

      // Önce DD.MM.YYYY formatını dene (ör: 19.06.2025)
      if (
        typeof orderCopy.fabricApproval === "string" &&
        orderCopy.fabricApproval.includes(".")
      ) {
        momentDate = moment(orderCopy.fabricApproval, "DD.MM.YYYY");
      } else {
        // Diğer formatlar için otomatik parsing
        momentDate = moment(orderCopy.fabricApproval);
      }

      if (momentDate.isValid()) {
        orderCopy.fabricApproval = momentDate.format("DD.MM.yyyy");
      } else {
        // Geçersiz tarih ise null yap
        orderCopy.fabricApproval = null;
      }
    } catch (error) {
      orderCopy.fabricApproval = null;
    }
  } else if (orderCopy.fabricApproval === "Invalid Date") {
    // Invalid Date string ise null yap
    orderCopy.fabricApproval = null;
  }

  let formData = new FormData();
  for (var keys in files.value) {
    formData.append("files", files.value[keys]);
  }
  for (var key in orderCopy) {
    if (orderCopy[key] != null) {
      formData.append(key, orderCopy[key]);
    }
  }

  store
    .dispatch(Actions.UPDATE_ORDER, formData)
    .then((x) => {
      if (x.success) {
        success(x.message);
        store.dispatch(Actions.ORDER_DETAIL, order.value.id);
        files.value = [];
        //router.push({ name: "order-detail", params: { id: order.value.id } });
      } else {
        error(x.message);
      }
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    })
    .catch((x) => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      error("Tüm alanları doldurun!");
    });
};
const success = (message) => {
  toast.add({
    severity: "success",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};

const error = (message) => {
  toast.add({
    severity: "error",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const flag = ref(false);
const newDate = ref();
const changeEstimatedShippingDate = (event) => {
  newDate.value = moment(event.target.value).format();
};

const setFlag = (args) => {
  flag.value = true;
};
watchEffect(() => {
  if (!flag.value) {
    order.value.estimatedShippingDate = moment(
      store.state.OrderModule.order.value.estimatedShippingDate
    ).format("yyyy-MM-DD");
  } else {
    flag.value = false;
  }
});
// onBeforeUpdate(() => {
//   console.log(moment(order.value.estimatedShippingDate).format("yyyy-MM-DD"))

//   console.log("**************************")

//   console.log(moment(store.state.OrderModule.order.value.estimatedShippingDate).format("yyyy-MM-DD"))
//    if(!flag.value)
//     {
//       order.value.estimatedShippingDate = moment(store.state.OrderModule.order.value.estimatedShippingDate).format("yyyy-MM-DD");
//       flag.value = true;
//     } else {
//       flag.value = false
//     }
// });

const clearFabricApproval = () => {
  order.value.fabricApproval = null;
};

// NexeraFileUpload bileşenindeki getFileKey hatasını düzeltmek için
const getFileKey = (args) => {
  // Boş bir fonksiyon, gerekirse doldurulabilir
};

// fabricApproval değişikliklerini izle ve geçersiz tarihleri handle et
watch(
  () => order.value.fabricApproval,
  (newValue) => {
    // String olarak "Invalid Date" gelirse null yap
    if (newValue === "Invalid Date") {
      order.value.fabricApproval = null;
    }
    // Date object ama invalid ise null yap
    else if (newValue instanceof Date && isNaN(newValue.getTime())) {
      order.value.fabricApproval = null;
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (props.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(Customer, {
              onChangeCustomer: selectedCustomer,
              data: customer
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(!props.data.flag ? 'col-md-12' : 'col-md-10')
              }, [
                _hoisted_7,
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: _unref(order).articleNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(order).articleNumber) = $event)),
                  class: "col-md-12"
                }, null, 8, ["modelValue"])
              ], 2),
              (props.data.flag)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("a", {
                      href: 
                'https://www.bader.de/shop/product/kleid-' +
                props.data.articleNumber +
                '-036'
              ,
                      style: {"font-weight":"bold"},
                      target: "_blank"
                    }, "Model Link", 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(Status, {
              onChangeStatus: selectedStatus,
              data: _unref(order)
            }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(Season, {
              onChangeSeason: selectedSeason,
              data: season
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: _unref(order).code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(order).code) = $event)),
                  class: "col-md-12"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_unref(Calendar), {
                    modelValue: _unref(order).fabricApproval,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(order).fabricApproval) = $event)),
                    dateFormat: "dd.mm.yy",
                    locale: trLocale,
                    class: "col-md-12"
                  }, null, 8, ["modelValue"]),
                  (_unref(order).fabricApproval)
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        icon: "pi pi-times",
                        onClick: clearFabricApproval,
                        class: "p-button-danger"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_unref(Checkbox), {
              id: "binary",
              modelValue: _unref(order).oekoTex,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(order).oekoTex) = $event)),
              binary: true
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(Department, {
              onChangeDepartment: selectedDepartment,
              data: department
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _unref(order).modelCode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(order).modelCode) = $event)),
              class: "col-md-12"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_Textarea, {
              modelValue: _unref(order).explain,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(order).explain) = $event)),
              rows: "3",
              cols: "100",
              placeholder: "Açıklama"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(Brand, {
              onChangeBrand: selectedBrand,
              data: brand
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(ShippingTypes, {
              onChangeShippingType: selectedShippingType,
              data: shippingType
            })
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(OrderTypes, {
              onChangeOrderType: selectedOrderType,
              data: orderType
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(order).date) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _unref(order).date]
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(order).estimatedShippingDate) = $event)),
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (setFlag(true))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _unref(order).estimatedShippingDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(order).estimatedDeliveryDate) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _unref(order).estimatedDeliveryDate]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createVNode(Supplier, {
              onChangeSupplier: selectedSupplier,
              data: supplier
            })
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createVNode(NexeraFileUpload, {
              onData: getFileKey,
              onUpload: upload
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.files, (file, index) => {
            return (_openBlock(), _createBlock(File, {
              "file-title": file.name,
              "file-type": file.extension,
              "file-url": file.url,
              onRemoveFile: ($event: any) => (removeFiles(file.id)),
              key: index
            }, null, 8, ["file-title", "file-type", "file-url", "onRemoveFile"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_51, [
          (
          _unref(order) && JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 3)
        )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-light-primary",
                style: {"float":"right","margin-left":"auto"},
                onClick: updateOrder
              }, " Güncelle "))
            : (
          JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 3)
        )
              ? (_openBlock(), _createElementBlock("button", _hoisted_52, " Kaydet "))
              : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})